import { del, get, jsonParser, post, put } from "./Client";

export const getAttribute = (attribute) => 
  get(`/attributes/${attribute.id}`).then(jsonParser);

export const createAttribute = (attribute) =>
  post("/attributes", { body: attribute }).then(jsonParser);

export const updateAttribute = (attribute) =>
  put(`/attributes/${attribute.id}`, { body: attribute }).then(jsonParser);

export const deleteAttribute = (attribute) => 
  del(`/attributes/${attribute.id}`).then(jsonParser);

export const listAttributesByCategoryIdAndType = (categoryId, type, sort = "order", order = "ASC", parentId = null) =>
  get(`/attributes/all/category/${categoryId}?sort=${sort}&order=${order}${!!type ? "&type=" + type : ""}${!!parentId ? "&parentId=" + parentId : ""}`).then(jsonParser);

export const searchAttributes = (query, all = false, page = 0, sort = "order", order = "ASC", drinkId = null, categoryId = null, type = null) =>
  get(`/attributes/alt-list?query=${query}&all=${all ? "true" : "false"}&page=${page}&sort=${sort}&order=${order}${!!drinkId ? "&drinkId=" + drinkId : ""}${!!categoryId ? "&categoryId=" + categoryId : ""}${!!type ? "&type=" + type : ""}`)
    .then(jsonParser);

export const importAttributeExcelData = (data) =>
  post("/attributes/import/excel", { body: data }).then(jsonParser);